<template><slot></slot></template>

<script setup>
import {
  getCurrentInstance,
  onBeforeUnmount,
  onMounted,
  onUnmounted
} from 'vue';

const props = defineProps({
  emitOnMounted: String,
  dataOnMounted: Object,
  emitOnUnmounted: String,
  reactOn: String,
  handler: Function,
  mountEventDelay: Number,
  actionOnMounted: Function
});

const { proxy } = getCurrentInstance();
if (props.reactOn) {
  proxy.$bus.on(props.reactOn, props.handler);
}
onMounted(async () => {
  if (props.emitOnMounted) {
    setTimeout(() => {
      proxy.$bus.emit(props.emitOnMounted, props.dataOnMounted || {});
    }, props.mountEventDelay || 0);
  }
  if (props.actionOnMounted) props.actionOnMounted();
});
onBeforeUnmount(() => {
  if (!props.reactOn) return;
  proxy.$bus.off(props.reactOn, props.handler);
});
onUnmounted(() => {
  if (!props.emitOnUnmounted) return;
  proxy.$bus.emit(props.emitOnUnmounted);
});
</script>
